import Vue from 'vue'
import Router from 'vue-router'
import routes from './router'
import store from '../store'
import Cookies from 'js-cookie'
import Util from '@/base/js/util'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import {
  Message
} from 'element-ui' 

Vue.use(Router)
NProgress.configure({
  showSpinner: false
})

export const router = new Router({
  // mode: 'history',
  routes: routes
})

//全局导航首位
router.beforeEach((to, from, next) => {
  NProgress.start()
  Util.title(to.meta.title)
  if (store.state.userInfo&&store.state.userInfo.userinfo.id) {
    if (to.name !== 'login') {
      //请求前校验token，校验用户登录状态
      //判断本地存储的和vuex存储的是不是一内容
      const cookie_info = Cookies.get('userInfo')
      const store_info = store.state.userInfo.userinfo
      if (cookie_info && store_info && cookie_info != store_info) {
        Message.warning('登录状态发生变化')
        location.reload()
      }
      //判断路由表是否已经生成
      if (store.state.addRoutes.length === 0) {
        // console.log(store.state.addRoutes);
        store.dispatch('GenerateRoutes').then(() => { // 生成可访问的路由表
          router.addRoutes(store.state.addRoutes) // 动态添加可访问路由表
          next({
            ...to,
            replace: true
          }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
        })
      } else {
        Util.toDefaultPage(routes, to.name, router, next)
      }
    } else if (to.name === 'login') {
      next({
        path: '/',
        replace: true
      })
    }
  } else if (to.name !== 'login' && to.name !== 'password-find') { //未登录跳转登录页面
    if (from.name != 'login') {
      next({
        name: 'login',
        replace: true
      })
    } else {
      next(false)
      NProgress.done()
    }
  } else { //未登录去修改密码
    next()
  }
})
router.afterEach((to) => {
  NProgress.done()
  window.scrollTo(0, 0);
});
